import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function LoginModal({ isOpen, onClose, setUser }) {
    const [mode, setMode] = useState("login");
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    const [form, setForm] = useState({
        name: "",
        email: "",
        password: "",
    });

    if (!isOpen) return null;

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: "" });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let newErrors = {};

        // Validation
        if (mode === "register" && !form.name.trim()) {
            newErrors.name = "Full name is required";
        }

        if (!form.email.trim()) {
            newErrors.email = "Email is required";
        }

        if (!form.password.trim()) {
            newErrors.password = "Password is required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        try {
            // REGISTER
            if (mode === "register") {
                await axios.post("https://hotel.southtravels.com/api/register", {
                    name: form.name,
                    email: form.email,
                    password: form.password,
                    password_confirmation: form.password,
                });

                alert("User registered successfully");
                setMode("login");
                onClose();
            }

            // LOGIN
            if (mode === "login") {
                const res = await axios.post("https://hotel.southtravels.com/api/login", {
                    email: form.email,
                    password: form.password,
                });

                const userData = res.data.user;

                // Save user
                localStorage.setItem("user", JSON.stringify(userData));
                setUser(userData);

                alert("Login successful");

                // ✅ CLOSE MODAL FIRST
                onClose();

                // ✅ REDIRECT TO PROFILE
                navigate("/profile");
            }

        } catch (err) {
            console.error(err);
            alert("Authentication failed");
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
            <div className="bg-white w-[90%] max-w-md rounded-xl shadow-lg p-6 relative">

                <button onClick={onClose} className="absolute top-3 right-3">
                    ✕
                </button>

                <h2 className="text-2xl text-center mb-4">
                    {mode === "register" ? "Create Account" : "Sign In"}
                </h2>

                <form onSubmit={handleSubmit} className="space-y-4">

                    {mode === "register" && (
                        <>
                            <input
                                name="name"
                                placeholder="Full Name"
                                onChange={handleChange}
                                className="w-full border px-4 py-2 rounded"
                            />
                            {errors.name && (
                                <p className="text-red-500 text-sm">{errors.name}</p>
                            )}
                        </>
                    )}

                    <input
                        name="email"
                        type="email"
                        placeholder="Email"
                        onChange={handleChange}
                        className="w-full border px-4 py-2 rounded"
                    />
                    {errors.email && (
                        <p className="text-red-500 text-sm">{errors.email}</p>
                    )}

                    <input
                        name="password"
                        type="password"
                        placeholder="Password"
                        onChange={handleChange}
                        className="w-full border px-4 py-2 rounded"
                    />
                    {errors.password && (
                        <p className="text-red-500 text-sm">{errors.password}</p>
                    )}

                    <button className="w-full bg-teal-600 text-white py-2 rounded">
                        {mode === "register" ? "Register" : "Login"}
                    </button>
                </form>

                <div className="text-center mt-4">
                    {mode === "login" ? (
                        <button onClick={() => setMode("register")}>
                            Create account
                        </button>
                    ) : (
                        <button onClick={() => setMode("login")}>
                            Back to login
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}